__turbopack_context__.v({
  "eyebrow": "PaidAdsPpcServicesCardSection-module__TSiRha__eyebrow",
  "heading": "PaidAdsPpcServicesCardSection-module__TSiRha__heading",
  "section": "PaidAdsPpcServicesCardSection-module__TSiRha__section",
  "title": "PaidAdsPpcServicesCardSection-module__TSiRha__title",
});
